import DocumentCreationButton from 'Components/DocumentCreationButton';
import { Item } from 'Components/Grid';
import HistoryRowControls from 'Components/HistoryRowControls';
import HistoryRowListing from 'Components/HistoryRowListing';
import HistorySection from 'Components/HistorySection';
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { formatPartialDate } from 'Utility/date';

const Spirometry = ({ documents, startEdit, view }: IOwnProps): React.JSX.Element => {
  return (
    <HistorySection
      headerText={<FormattedMessage id="clpAndCnpTests.spirometry" />}
      newButton={
        <DocumentCreationButton
          name="spirometry"
          text="clpAndCnpTests.newSpirometry"
          onClick={startEdit({}, 'spirometry')}
          width={15}
          height={3}
          fontSize={14}
          alternate={true}
        />
      }
    >
      <HistoryRowListing
        documents={documents}
        headers={
          <>
            <Item xs={2}>
              <FormattedMessage id="general.date" />
            </Item>
            <Item xs={10}></Item>
          </>
        }
        contentFormat={d => (
          <>
            <Item xs={2} style={{ fontWeight: 600 }}>
              {formatPartialDate(d.date)}
            </Item>
            <Item xs={7} />
            <Item xs={3}>
              <HistoryRowControls document={d} startEdit={startEdit} view={view} />
            </Item>
          </>
        )}
      />
    </HistorySection>
  );
};

interface IOwnProps {
  documents: IDocumentWithTypeV2<'spirometry'>[];
  startEdit: StartEdit;
  view?: IView;
}

export default Spirometry;
